import React, { useState } from "react";
import GroupApi from "../../api/GroupApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function AddDetails({ onAdded }) {
  const [group, setGroup] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!group.trim()) {
      setErrors({ group: "Group is required" });
      return;
    }

    try {
      const res = await GroupApi.add({ group });
      showSuccess(res.message);
      document.getElementById("closeAddModalBtn").click();

      setGroup("");
      setErrors({});

      if (onAdded) onAdded();
    } catch (err) {
     showError(err.message);
    }
  };

  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Add Group</h4>
          <button type="button" className="btn-close" data-bs-dismiss="modal" id="closeAddModalBtn" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body container">
            <div className="mb-3">
              <label className="form-label">Group</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Group"
                value={group}
                onChange={(e) => setGroup(e.target.value)}
              />
              {errors.group && (
                <span className="text text-danger">{errors.group}</span>
              )}
              {errors.api && (
                <span className="text text-danger">{errors.api}</span>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Add
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddDetails;
